<a [href]="url" [class]="class">
  <ng-content></ng-content>
</a>
